import type { TherapistSearchRequestDtoOrderEnum, TherapistSearchRequestDtoOrderTermsEnum } from '@app/api';

export enum UserGender {
  MALE = 'male',
  FEMALE = 'female',
  TRANSGENDER = 'transgender',
  UNKNOWN = 'unknown',
  ANY = 'any',
}

export enum UserGenderLabels {
  FEMALE = 'Женщина',
  MALE = 'Мужчина',
  TRANSGENDER = 'Трансгендер',
  UNKNOWN = 'Неопределенный',
  ANY = 'Не важно',
}

export enum FilterInputType {
  Radio = 'radio',
  Checkbox = 'checkbox',
  Switch = 'switch',
  Slider = 'slider',
  Range = 'range',
  RangeSecond = 'rangeSecond',
}

export enum BreakpointsEnum {
  lg = 1440,
  lgm = 1200,
  md = 1024,
  ms = 820,
  sm = 768,
  s = 576,
  xl = 385,
  xs = 320,

  tablet = 1100,
  mb = 500,
}

export type BreakpointsType = keyof typeof BreakpointsEnum;

export enum AllTherapistsTab {
  all = 'all',
  recommended = 'recommended',
}

export enum DayLimitEnum {
  Today = 'Ближайшие 24 часа',
  ThreeDays = 'Ближайшие 3 дня',
  Week = 'Ближайшая неделя',
  Month = 'Ближайший месяц',
  NoMatter = 'Не важно',
}

export enum PriceEnum {
  To3000 = 'До 3.000 руб',
  To4000 = 'До 4.000 руб',
  To5000 = 'До 5.000 руб',
  To8000 = 'До 8.000 руб',
  from8000 = 'От 8.000 руб и более',
}

export interface ConvertAppliedFiltersToQueryParams {
  selectedFiltersValues: any;
  selectedFiltersDiseases: string[] | string;
  selectedSorting?: {
    order?: TherapistSearchRequestDtoOrderEnum;
    orderTerms?: TherapistSearchRequestDtoOrderTermsEnum;
  };
  page: number;
  tab?: AllTherapistsTab;
  searchValue?: string;
  childOld?: number | undefined;
  therapistOld?: string | undefined;
}

export type CommonComponentTypes = {
  className?: string;
};

export interface SendingFrequencyError {
  status: number;
  data: {
    statusCode: number;
    timestamp: string;
    message: string;
    error: string;
    data: {
      secondsBeforeNextAttempt: number;
    };
    path: string;
  };
}

export interface CustomError {
  status: number;
  data: {
    statusCode: number;
    timestamp: string;
    message: string;
    error: string;
    data: Record<string, unknown>;
    path: string;
  };
}

export enum LayoutEnum {
  Main = 'main',
  Therapist = 'therapist',
  Client = 'client',
  Auth = 'auth',
  ClientProfile = 'clientProfile',
  TherapistProfile = 'therapistProfile',
  Business = 'business',
  Back = 'back',
  BackV2 = 'backV2',
  Medsi = 'medsi',
}

export type PaymentOrderTerms = 'value' | 'dealStartDate' | 'createdAt';

export enum TypeAdvice {
  consultation = 'Консультация',
  mySupervision = 'Моя супервизия',
  supervision = 'Супервизия',
  cancelled = 'Отменено',
}

export type ClientsOrderTerms = 'firstName' | 'totalSessions' | 'firstSessionDate' | 'lastSessionDate';

export interface TherapistData {
  id: string;
  firstname: string;
  avatarKey?: string | null;
}

export enum InputState {
  success = 'success',
  error = 'error',
}
